export default __webpack_public_path__ + "static/media/typewriter1152.3632be05.jpg";